import { normalizeUserQuantity } from "../../../normalizers/normalizeUserQuantity";

export function handleUserQuantityDefinitionUpdated(state, payload) {
    const { category, quantity_definition } = payload;

    const quantity = normalizeUserQuantity(quantity_definition);
    const quantityId = quantity.nodeId;

    const newCategoryId = category?.id ?? "root";

    // 1. CATEGORY GUARD (important)
    const categoryExists = !!state.categoriesById?.[newCategoryId];

    if (!categoryExists) {
        // ignore stale or invalid event
        return state;
    }

    // 2. update global map only
    const quantitiesById = {
        ...state.quantitiesById,
        [quantityId]: {
            ...state.quantitiesById[quantityId],
            ...quantity,
            categoryId: newCategoryId,
        },
    };

    return {
        ...state,
        quantitiesById,
    };
}